<template>
    <main class="main-content" id="main-content">
        <div class="container" v-if="loaded">
          <section class="section">
            <page-header>
                <template v-slot:pageTitle>
                  {{$t("messages")}}
                </template>
            </page-header>
            <div class="section__body">
              <div class="messages" v-if="sortedMessages.length">
                <div class="messages__header">
                  <div class="row no-gutters justify-content-end">
                    <div class="col-auto">
                      <button class="btn btn_sort btn_with-icon" :class="{active: sortType ==='type'}" type="button" @click="sortMessages('type')" data-sort="type"><span class="btn__text">{{$t("type")}}</span><span class="btn__icon svg-icon" aria-hidden="true">
                          <svg role="img" width="10" height="10" aria-hidden="true">
                            <use xlink:href="#svg-icon-arrow-next"></use>
                          </svg></span></button>
                    </div>
                    <div class="col-auto">
                      <button class="btn btn_sort btn_with-icon" :class="{active: sortType ==='date'}" type="button" @click="sortMessages('date')" data-sort="date"><span class="btn__text">{{$t("date")}}</span><span class="btn__icon svg-icon" aria-hidden="true">
                          <svg role="img" width="10" height="10" aria-hidden="true">
                            <use xlink:href="#svg-icon-arrow-next"></use>
                          </svg></span></button>
                    </div>
                  </div>
                </div>
                <div class="messages__body">
                  <div v-for="message in sortedMessages" :key="message.id" class="messages-item" @click="$router.push(`/message/${message.id}`)" :class="{new: message.status !== 2}" tabindex="0">
                    <div class="messages-item__title">{{message.message_object.title}}</div>
                    <div class="messages-item__descr">{{truncate(message.message_object.content)}}</div>
                    <div class="messages-item__type">{{message.message_object.type}}</div>
                    <div class="messages-item__date">{{formatDate(message.message_object.created_at)}}</div>
                    <div class="messages-item__control">
                      <button class="btn btn_remove svg-icon" type="button" @click.prevent.stop="confirmDelMessage(message)" :aria-label='$t("deleteMessage")' data-target="#modal-remove-message" data-toggle="modal">
                        <svg role="img" width="14" height="14" aria-hidden="true">
                          <use xlink:href="#svg-icon-close"></use>
                        </svg>
                      </button>
                    </div>
                    <div class="messages-item__bg box bg-white" aria-hidden="true"></div>
                  </div>
                </div>
              </div>
              <div v-else>
                {{$t("notNewMessage")}}
              </div>
            </div>
          </section>
        </div>
    </main>

    <div class="modal fade modal_remove-message" ref="modalRemoveMessage" id="modal-remove-message" :aria-label='$t("deleteMessage")' tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
              {{$t("deleteMessage")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" @click.prevent="closeModal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <div class="section__description color-green">
              <p>{{$t("deleteMessage")}} "{{messageTitle}}"?</p>
            </div>
            <div class="btn-group">
              <div class="row">
                <div class="col-12 col-md-6">
                  <button class="btn btn_default btn_green js-remove-message" @click.prevent="delMessage" type="button">{{$t("yes")}}</button>
                </div>
                <div class="col-12 col-md-6 order-last order-md-first">
                  <button class="btn btn_default btn_white" type="button" @click.prevent="closeModal" data-dismiss="modal">{{$t("not")}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import PageHeader from "@/components/PageHeader";
import ModalWindow from "@/components/UI/ModalWindow";
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex' 
export default {
  components: {
    PageHeader
  },
  data() {
    return {
      sortType: '',
      messageTitle: '',
      loaded: false
    }
  },
  methods: {
    ...mapMutations({
      sortingMessages: 'messages/sortMessages',
      setMessageId: 'messages/setMessageId',
    }),
    ...mapActions({
      getMessages: 'messages/getMessages',
      deleteMessage: 'messages/deleteMessage',
    }),
    sortMessages(type) {
      this.sortType = type
      this.sortingMessages(type)
    },
    formatDate(dateStr) {
      let separatorIdx = dateStr.indexOf('T')
      let dateArr = dateStr.slice(0, separatorIdx).split('-')
      let date = `${dateArr[2]}.${dateArr[1]}.${dateArr[0]}`
      let time =  dateStr.substr(separatorIdx+1, 8)

      return `${date} ${time}`
    },
    removeHtmlTags(str) {
      return str.replace(/<[^>]*>/g, '');
    },
    truncate(str) {
      str = this.removeHtmlTags(str);
      const maxlength = 50;
      return (str.length > maxlength) ? str.slice(0, maxlength - 1) + '…' : str;
    },
    confirmDelMessage(mess) {
      this.setMessageId(mess.id);
      this.messageTitle = mess.message_object.title
      this.$refs.modalRemoveMessage.classList.add('modal_show')
    },
    delMessage(){
      this.deleteMessage().then( () => {
        this.getMessages();
        this.closeModal();
      })
    },
    closeModal(){
      document.getElementById('modal-remove-message').classList.remove('modal_show')
    }
  },
  computed: {
    ...mapGetters({
      sortedMessages: 'messages/sortedMessages'
    })
  },
  created() {
    document.querySelector('.preloader').classList.remove('d-none')
    this.getMessages().then(res => {
      if(res === 200){
        document.querySelector('.preloader').classList.add('d-none');
        this.loaded = true
      }
    });
  }
}
</script>
<style scoped>
.messages-item{
  cursor: pointer;
}
.modal_show{
  display: block;
  opacity: 1;
  background: rgba(255,255,255,.5);
}
</style>